import { render, staticRenderFns } from "./ProfileAddress.vue?vue&type=template&id=62ab935b"
import script from "./ProfileAddress.vue?vue&type=script&lang=ts"
export * from "./ProfileAddress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports